import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import {
  initialGatePassPageState,
  GatePassItemData,
} from "../core/_model.gatePass";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedGatePass = {
  data: GatePassItemData | null;
  action: ActionsKey;
};

type GatePassDataType = {
  gatePassList: any;
  detail: GatePassItemData | null;
  actioned: ActionedGatePass | null;
  totalItems?: number;
  setDetail: (detail: GatePassItemData | null) => void;
  setGatePassList: (list: DefaultListResponse | null) => void;
  setActioned: (act: ActionedGatePass | null) => void;
};

export const useGatePassStore = create<GatePassDataType>(
  (set) => ({
    gatePassList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setGatePassList: (gatePassData) =>
      set((state) => ({
        gatePassList: gatePassData?.member,
        totalItems: gatePassData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useGatePassListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialGatePassPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
